<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a Sample</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Sample Type*</label>
            <v-select 
              required
              :options="requestReasons"
              v-model="sample.sample_type"
            />
          </div>

          <div class="field">
            <label class="label">Product*</label>
            <product-search
              required
              :product-category-id="13"
              v-model="sample.product_master_id"
              :selected.sync="productSelected"/>            
            <!-- <v-select 
              required
              :options="products"
              item-text="name"
              item-value="id"
              v-model="sample.product_master_id"/> -->
          </div>

          <div class="field">
            <label class="label">Sample Image*</label>
            <v-file-upload
              class="is-fullwidth"
              has-name
              v-model="image"/>
            <div class="help">
              Upload an image of the sample if the client has a special request
            </div>
          </div>

          <div class="field">
            <label class="label">Name*</label>
            <v-text-field 
              required
              placeholder="Enter Sample Name"
              v-model="sample.name"/>
          </div>

          <div class="field">
            <label class="label">Description*</label>
            <v-text-field 
              required
              placeholder="Enter Sample Description"
              v-model="sample.desc"/>
          </div>

          <div class="columns">
            <div class="column">
              <label class="label">Color*</label>
              <v-text-field 
                required
                placeholder="Enter Sample Color"
                v-model="sample.color"/>
            </div>
            
            <div class="column">
              <label class="label">Pattern*</label>
              <v-text-field 
                required
                placeholder="Enter Sample Pattern"
                v-model="sample.pattern"/>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <label class="label">Quantity Available*</label>
              <v-text-field 
                required
                type="number"
                placeholder="Quantity Available"
                v-model="sample.qty_available"/>
            </div>

            <div class="column">
              <label class="label">Quantity With Clients*</label>
              <v-text-field 
                required
                type="number"
                placeholder="Quantity With Clients"
                v-model="sample.qty_with_clients"/>
            </div>
          </div>

          <div class="field">
            <label class="label">Sample Shelf Number*</label>
            <v-text-field 
              required
              placeholder="Enter Sample Shelf Number"
              v-model="sample.shelf_number"/>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid || saving"
            :class="{ 'is-loading': saving }"
            class="button is-primary" 
            @click.stop="addNew()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'
import VFileUpload from '@/components/base/VFileUpload'
import ProductSearch from '@/components/inventory/ProductSearch'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { 
    VTextField, 
    VForm, 
    VSelect,
    VFileUpload,
    ProductSearch
  },
  data() {
    return {
      sample: {
        product_master_id: null,
        name: null,
        desc: null,
        color: null,
        pattern: null,
        qty_available: null,
        qty_with_clients: null,
        sample_type: null,
        shelf_number: null
      },
      image: null,
      productSelected: null,
      valid: false,
      saving: false
    }
  },
  computed: {
    ...mapState("products", ["products"]),
    ...mapState("sampleRequests", ["requestReasons"])
  },
  created() {
    this.initialize();
  },
  methods: {
    // ...mapActions("products", ["getProducts"]),
    ...mapActions("samples", ["addSample", "addSampleImage"]),
    initialize() {
      // this.getProducts({ product_category_id: 13, per_page: 100 });
    },
    addNew() {
      this.saving = true;
      this.addSample(this.sample).then(resp => {
        if (this.image) {
          let formData = new FormData();
          formData.append('image', this.image.file, this.image.name);
          this.addSampleImage({
            sampleId: resp.data.id,
            data: formData
          }).then(() => {
            this.saving = false;
            this.close(true);
          }).catch(() => this.saving = false);
        } else {
          this.saving = false;
          this.close(true);
        }
      }).catch(() => this.saving = false);
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
